import { useState } from 'react'
import styled from 'styled-components'
import {
	useMapRequests,
	useRequestsCounters,
} from '../../api/hooks/use.request'
import ScrollTopButtonComponent from '../../components/ui/button.component/scroll.top.button.component'
import { HeadingComponent } from '../../components/ui/heading.component'
import { PeriodType } from '../../types/statistics.types'
import { ProblemsFilterComponent } from './problems.filter.component'
import { RequestsMapComponent } from './requests.map.component'

export const RequestsPageContainer = styled.div`
	width: 95%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	max-width: 1440px;
	position: relative;
	padding: 200px 5px 50px 5px;

	@media (max-width: 1200px) {
		max-width: 90%;
	}
`
export const PeriodWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;

	@media(max-width: 768px) {
	 flex-direction: column;
	}

`

export const CountsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 50px;

	@media(max-width: 530px) {
	     gap: 25px;
	}
`
export const CountItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`
export const CountNumber = styled.div<{ color?: string }>`
	font-family: 'e-Ukraine-Head', sans-serif;
	font-weight: 500;
	font-size: 40px;
	line-height: 1;
	min-height: 48px; 
	color: ${({ color }) => color};

	@media (max-width: 768px) {
		font-size: 36px;
		min-height: 44px;
	}

	@media (max-width: 530px) {
		font-size: 32px;
		min-height: 40px;
	}
`
export const CountValue = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #555;

	@media (max-width: 768px) {
		font-size: 13px;
	}
	@media (max-width: 530px) {
		font-size: 12px;
	}
`

export const PeriodBtn = styled.div<{ $active: boolean }>`
	font-family: 'e-Ukraine', sans-serif;
	padding: 8px 20px;
	font-size: 14px;
	border-radius: 18px;
	border: 1.5px solid ${({ $active }) => ($active ? '#01924f' : 'transparent')};
	background: transparent;
	color: ${({ $active }) => ($active ? '#01924f' : '#8f8f8f')};
	cursor: pointer;
	line-height: 114%;
	transition: all 0.2s ease;

	&:hover {
		color: #01924f;
	}

	@media (max-width: 768px) {
		font-size: 11px;
		padding: 8px 14px;
	}

	@media (max-width: 530px) {
		padding: 5px 10px;
	}
`

export const AnalyticsToolbar = styled.div`
	display: flex;
	align-items: center;
	justify-content: end;
	width: 100%;
	gap: 90px;
	margin-top: 46px;

	@media (max-width: 1024px) {
	 justify-content: space-between;
	 gap: 0px;
	}

	@media(max-width: 530px) {
	margin-top: 20px;
	
	}
	
`

export const AnalyticsToolbarContainer = styled.div`
	display: flex;
	justify-content: end;
	align-items: center;
	width: 100%;
	margin-bottom: 25px;

	@media(max-width: 1024px) {
	 margin-bottom: 30px;
	}
`

const PERIODS: { key: PeriodType; label: string }[] = [
	{ key: 'today', label: 'за поточну добу' },
	{ key: '7days', label: 'за 7 днів' },
	{ key: '30days', label: 'за 30 днів' },
]

export const RequestsPage = () => {
	const [period, setPeriod] = useState<PeriodType>('today')
	const [selectedProblemId, setSelectedProblemId] = useState<
		number | undefined
	>()


	const { data: points = [], isLoading: isPointsLoading } = useMapRequests(selectedProblemId, period)
	const { data: counts } = useRequestsCounters(period) 

	return (
		<RequestsPageContainer>
			<HeadingComponent
				title={<>Мапа <br /> звернень</>}
				description='
				 Тут ви можете переглянути зареєстровані звернення на інтерактивній мапі та скористатися інструментами сортування для швидкого пошуку необхідної інформації 
				 '
				breadcrumbs={[
					{ title: 'Головна', path: '/' },
					{ title: 'Мапа звернень', path: '/requests' },
				]}
			/>
			<AnalyticsToolbarContainer>
				
				<AnalyticsToolbar>
					<CountsContainer>
						<CountItemContainer>
							<CountNumber color='#fabe42'>{counts?.inWork}</CountNumber>
							<CountValue>В роботі</CountValue>
						</CountItemContainer>
						<CountItemContainer>
							<CountNumber color='#09723c'>{counts?.processed}</CountNumber>
							<CountValue>Опрацьовано</CountValue>
						</CountItemContainer>
					</CountsContainer>
					<PeriodWrapper>
						{PERIODS.map(p => (
							<PeriodBtn
								key={p.key}
								$active={period === p.key}
								onClick={() => setPeriod(p.key)}
							>
								{p.label}
							</PeriodBtn>
						))}
					</PeriodWrapper>
				</AnalyticsToolbar>
			</AnalyticsToolbarContainer>

			<ProblemsFilterComponent
				selectedProblemId={selectedProblemId}
				onChange={id => {
					setSelectedProblemId(id)
				}}
			/>

			<RequestsMapComponent
				allPoints={points}
				period={period}
				selectedProblemId={selectedProblemId}
				isLoading={isPointsLoading}
			/>
			<ScrollTopButtonComponent />
		</RequestsPageContainer>
	)
}
